import { render, staticRenderFns } from "./Tsjy.vue?vue&type=template&id=63121315&"
import script from "./Tsjy.vue?vue&type=script&lang=js&"
export * from "./Tsjy.vue?vue&type=script&lang=js&"
import style0 from "./Tsjy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports